
export default function address(data) {
  const dataPesanan = data || {};

  
  return `
<!DOCTYPE html>
<html lang="id">
<head>
  <meta charset="UTF-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Transaksi ${dataPesanan?.id}</title>
  <style>
    html,
    body {
      padding: 0;
      margin: 0 auto;
      font-family: "Arial", Helvetica, sans-serif;
      font-size: 14px;
      max-width: 2in;
    }

    .receipt {
      width: 2in;
      padding: .5em;
      font-size: 12px;
      border: solid 3px;
    }

   table{
       width: 100%;
       border-collapse: collapse;
   }
   td, th{
    padding: .2em .1em;
    vertical-align: top;
   }


    @page {
      margin: .1in !important;
    }

    @media print {
      html,
      body {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  </style>
</head>
<body>
  <div class="receipt">
  <div style="text-align: right;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 43"
      width="60px"
    >
      <path d="M99.5 31.367a11.526 11.526 0 01-4.559 1.716l-9.087-7.753v7.891h-4.271V1.101h4.271v16.213l7.496-7.659c1.741.019 3.388.426 4.866 1.133L87.833 21.403 99.5 31.367zM35.209 9.627V33.2h-11.6c-6.453 0-11.701-5.237-11.701-11.69v-.193c0-6.442 5.249-11.69 11.701-11.69h11.6zm-4.272 4.26h-7.328c-4.101 0-7.43 3.34-7.43 7.43v.193a7.433 7.433 0 007.43 7.43H30.937V13.887zM12.644 28.96h-.442a7.433 7.433 0 01-7.43-7.43v-7.624h4.397v-4.26H4.772V5.375H.5V21.531c0 6.453 5.249 11.69 11.701 11.69h5.206a13.378 13.378 0 01-4.763-4.261zm42.493-3.695c-1.288 2.206-3.672 3.695-6.41 3.695h-5.854v4.26h5.855c3.375 0 6.411-1.441 8.548-3.731a13.207 13.207 0 01-2.139-4.224zM79.458 9.646H67.859c-3.374 0-6.409 1.443-8.546 3.733a13.197 13.197 0 012.137 4.225c1.288-2.205 3.672-3.698 6.409-3.698h7.884V28.96h-7.884a7.433 7.433 0 01-7.43-7.43v-.194c0-6.441-5.249-11.69-11.701-11.69H37.128V41.764H41.4V13.907h7.328c4.101 0 7.43 3.34 7.43 7.43v.194c0 6.453 5.249 11.69 11.701 11.69h6.306V33.2h1.578v.02h4.272V9.646h-.557z"></path>
      <path d="M52.379 35.392a.538.538 0 01.378-.13.54.54 0 01.378.13.44.44 0 01.143.34.44.44 0 01-.143.34.538.538 0 01-.378.13.54.54 0 01-.378-.13.44.44 0 01-.143-.34.441.441 0 01.143-.34zm.755 1.69v4.606h-.763v-4.606h.763zM58.923 37.522c.33.344.495.84.495 1.489v2.676h-.763v-2.609c0-.458-.117-.811-.352-1.057-.235-.246-.554-.369-.956-.369-.419 0-.755.136-1.007.407-.252.271-.378.667-.378 1.187v2.441h-.763v-4.606h.763v1.091c.117-.375.326-.663.625-.864a1.815 1.815 0 011.036-.302c.536.001.97.173 1.3.516zM64.455 37.359c.31.224.527.523.65.898V35.48h.763v6.208h-.763v-1.174c-.123.375-.34.674-.65.898-.31.224-.689.336-1.137.336-.408 0-.772-.095-1.091-.285a1.973 1.973 0 01-.751-.818c-.182-.355-.273-.773-.273-1.254s.091-.9.273-1.258c.182-.358.432-.632.751-.822a2.09 2.09 0 011.091-.285c.448-.003.827.109 1.137.333zm-2.047.793c-.282.299-.424.712-.424 1.237 0 .526.141.938.424 1.237.282.299.659.449 1.128.449.302 0 .572-.07.81-.21a1.46 1.46 0 00.558-.591 1.87 1.87 0 00.201-.885c0-.336-.067-.632-.201-.889a1.423 1.423 0 00-.558-.591 1.594 1.594 0 00-.81-.206c-.469 0-.845.15-1.128.449zM72.018 37.082v4.606h-.763v-1.082a1.549 1.549 0 01-.625.86 1.84 1.84 0 01-1.044.298c-.531 0-.962-.172-1.292-.516-.33-.344-.495-.837-.495-1.481v-2.684h.763v2.609c0 .459.117.812.352 1.061.235.249.554.373.956.373.419 0 .755-.136 1.007-.407.252-.271.378-.667.378-1.187v-2.45h.763zM76.779 37.43c.316.271.508.636.575 1.095h-.73a1.058 1.058 0 00-.34-.675c-.193-.176-.452-.264-.776-.264-.274 0-.488.066-.642.197a.664.664 0 00-.231.533c0 .168.052.303.155.407a.984.984 0 00.386.235c.154.053.365.11.633.172.341.078.617.158.826.239.21.081.389.211.537.39.148.179.222.419.222.721 0 .375-.141.679-.424.914-.282.235-.659.352-1.128.352-.548 0-.996-.131-1.342-.394-.347-.263-.551-.629-.612-1.099h.738c.028.28.15.506.365.68.215.173.499.26.851.26.263 0 .468-.067.617-.201a.68.68 0 00.222-.529.579.579 0 00-.159-.428 1.05 1.05 0 00-.394-.243 5.673 5.673 0 00-.646-.176 6.304 6.304 0 01-.818-.235 1.252 1.252 0 01-.52-.373c-.143-.171-.214-.401-.214-.692 0-.386.143-.698.428-.935.285-.238.674-.357 1.166-.357.521-.001.939.135 1.255.406zM81.455 41.016v.671h-.57c-.47 0-.821-.112-1.053-.336-.232-.224-.348-.598-.348-1.124v-2.483h-.688v-.663h.688v-1.149h.772v1.149h1.191v.663h-1.191v2.5c0 .297.055.499.164.608.109.109.298.164.566.164h.469zM84.652 37.271c.291-.176.638-.264 1.04-.264v.831h-.235c-.431 0-.783.11-1.057.331-.274.221-.411.586-.411 1.095v2.424h-.763v-4.606h.763v.931a1.69 1.69 0 01.663-.742zM87.294 35.392a.538.538 0 01.378-.13.54.54 0 01.378.13.44.44 0 01.143.34.44.44 0 01-.143.34.538.538 0 01-.378.13.54.54 0 01-.378-.13.44.44 0 01-.143-.34c0-.14.048-.254.143-.34zm.755 1.69v4.606h-.763v-4.606h.763zM94.316 39.548h-3.683c.017.526.166.92.449 1.183.282.263.628.394 1.036.394.369 0 .678-.094.927-.281.249-.187.401-.438.457-.751h.814a1.924 1.924 0 01-1.124 1.443c-.308.14-.654.21-1.04.21a2.37 2.37 0 01-1.174-.285 2.017 2.017 0 01-.801-.818c-.193-.355-.289-.773-.289-1.254s.096-.9.289-1.258c.193-.358.46-.632.801-.822.341-.19.733-.285 1.174-.285.447 0 .837.095 1.17.285.333.19.587.445.763.763.176.319.264.671.264 1.057 0 .162-.011.302-.033.419zm-.906-1.224a1.234 1.234 0 00-.528-.512 1.608 1.608 0 00-.73-.168c-.419 0-.772.13-1.057.39-.285.26-.439.642-.461 1.145h2.945c.015-.341-.041-.626-.169-.855zM98.883 37.43c.316.271.508.636.575 1.095h-.73a1.058 1.058 0 00-.34-.675c-.193-.176-.452-.264-.776-.264-.274 0-.488.066-.642.197a.664.664 0 00-.231.533c0 .168.052.303.155.407a.984.984 0 00.386.235c.154.053.365.11.633.172.341.078.617.158.826.239.21.081.389.211.537.39.148.179.222.419.222.721 0 .375-.141.679-.424.914-.282.235-.659.352-1.128.352-.548 0-.996-.131-1.342-.394-.347-.263-.551-.629-.612-1.099h.738c.028.28.15.506.365.68.215.173.499.26.851.26.263 0 .468-.067.617-.201a.68.68 0 00.222-.529.579.579 0 00-.159-.428 1.05 1.05 0 00-.394-.243 5.673 5.673 0 00-.646-.176 6.304 6.304 0 01-.818-.235 1.252 1.252 0 01-.52-.373c-.143-.171-.214-.401-.214-.692 0-.386.143-.698.428-.935.285-.238.674-.357 1.166-.357.521-.001.939.135 1.255.406z"></path>
    </svg>
  </div>
  <table>
  <tbody>
  <tr>
  <th style="width: 30%; text-align: left;" colspan="2">PENERIMA</th>
  </tr>
  <tr>
  <td style="width: 30%;">Nama</td>
  <td>${dataPesanan?.detail?.nama || "-"}</td>
  </tr>
  <tr>
  <td style="width: 30%;">Kontak</td>
  <td>${dataPesanan?.detail?.kontak || "-"}</td>
  </tr>
  <tr>
  <td style="width: 30%;">Alamat</td>
  <td>${dataPesanan?.detail?.alamat || "-"}</td>
  </tr>
    <tr>
  <th style="width: 30%; text-align: left; padding-top: 1em;" colspan="2">PENGIRIM</th>
  </tr>
  <tr>
  <td style="width: 30%;">Nama</td>
  <td>Tapak Industries</td>
  </tr>
  <tr>
  <td style="width: 30%;">Kontak</td>
  <td>+62852 9847 6939 (WhatsApp Only)</td>
  </tr>
  <tr>
  <td style="width: 30%;">Alamat</td>
  <td>Jl. Sawerigading, Bongki, Sinjai Utara, Kab. Sinjai, Sulawesi Selatan</td>
  </tr>
  </tbody>
  </table>
  </div>
</body>
</html>`;
}
